<app-environment-ribbon></app-environment-ribbon>
<jhi-info-bar [pageType]="lastPage"></jhi-info-bar>
<div class="header-container" fxLayout="row" fxLayoutAlign="start">
  @if (showSnow()) {
    <div class="snow-container">
      <div class="inner-snow-container">
        <div class="snow"></div>
      </div>
    </div>
  }

  <div class="header-content" [class.snow-background]="showSnow()" fxLayout="row">
    <div class="sidenav-toggle-container" fxFlex="50px" fxLayoutAlign="center center" fxShow="true" fxHide.gt-sm>
      <a mat-icon-button (click)="toggleSidenav()">
        <fa-icon icon="bars"></fa-icon>
      </a>
    </div>
    <div fxFlex="190px" fxFlexOffset="50px" fxLayoutAlign="start center">
      <img class="logo-image" src="/content/images/sos_logo_primary.svg" width="137" height="35">
    </div>
    <div fxFlex fxLayoutAlign="end center">
      @if (userCustomerRoles?.length > 1) {
        <div class="pt-1 pe-2">View as role(s)</div>
        <div>
          <form [formGroup]="fg">
            <div class="common-drop-down" style="width: 300px;">
              <ng-select class="custom custom-height" [items]="userCustomerRoles" bindValue="customerRoleName" bindLabel="title" formControlName="customerRoleNames" placeholder="All" [clearable]="true" [searchable]="true" [multiple]="true" (change)="changeUserCustomerRoles($event)" dropdownPosition="bottom"></ng-select>
              <app-form-control-error-message [control]="fg.get('customerRoleNames')" labelKey="Customer role"></app-form-control-error-message>
            </div>
          </form>
        </div>
        <div class="ps-3" style="width: 20px;">
          @if (userCustomerRolesIsUpdating) {
            <app-spinner [noPadding]="true"></app-spinner>
          }
          @if (showRefresh) {
            <div class="force-cursor" fxLayout="row" fxLayoutAlign="center">
              <fa-icon icon="redo" size="lg" (click)="refresh()"></fa-icon>
            </div>
          }
        </div>
      }
      <div class="profile-container">
        <jhi-navbar></jhi-navbar>
      </div>
    </div>
  </div>
</div>
